<template>
    <div class="lang">
        <span class="activeLang" @click="isShowSelect = !isShowSelect">
          <img src="../../img/2022chinesepluslive/lang_icon.png" alt="">
          {{languageList[languageIndex].val}}
          <span class="caret" :class="{'activeCaret': isShowSelect}"></span>
        </span>
        <div class="list" v-show="isShowSelect" :class="{'menuActive': isShowSelect}">
          <span v-for="(lang, index) in languageList" :key="lang.name" @click="changeLanguage(lang.name, index)"
          :class="{'active': languageIndex == index}"
          >
            {{lang.val}}
          </span>
        </div>
        
    </div>
</template>

<script>
import { setup } from "../../../locales"
export default {
    name: 'ztHeader',
    computed: {
        language: {
            get() {
                return this.languageList[this.languageIndex].val;
            },
            set() {
                return this.languageList[this.languageIndex].val;
            }
        }
    },
    data: function () {
        return {
            isShowSelect: false,
            languageIndex: 0,
            languageList: [
                { 
                name: "cn",
                val: "中文"
                },
                {
                name: "en",
                val: "English"
                },
                {
                name: "es",
                val: "Español"
                },
                {
                name: "fr",
                val: "Français"
                },
                {
                name: "ru",
                val: "Русский"
                }
            ],
        }
    },
    methods: {
        // 切换语言
        changeLanguage(language, index) {
          setup(language)
          this.languageIndex = index
          this.isShowSelect = false
        },
        setDefaultLanguage() {
        let currentLanguage = window.localStorage.getItem("localeLanguage")
            for (let i = 0; i < this.languageList.length; i++) {
              if (currentLanguage == this.languageList[i].name) {
                this.language = this.languageList[i].val;
                this.languageIndex = i
              }
            }
        },
    },
    created () {
        this.setDefaultLanguage()
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.lang {
  display: inline-block;
  position: relative;
  margin-right: 0.1rem;
  .activeLang {
    font-size: 0.28rem;
    padding: 0.08rem 0.08rem 0.08rem 0.08rem;
    border-radius:  0.1rem;
    color: #6173bf;
    background-color: #fff;
    cursor: pointer;
    img {
      vertical-align: middle;
      width: 0.28rem;
    }
    .caret {
        display: inline-block;
        width: 0;
        height: 0;
        margin-bottom: 3px;
        margin-left: 3px;
        vertical-align: middle;
        border-top: 6px dashed;
        border-top: 6px solid\9;
        border-right: 6px solid transparent;
        border-left: 6px solid transparent;
        opacity: .9;
    }
    .activeCaret {
        border-top: none;
        border-bottom: 6px dashed;
    }
  }
  .list {
    position: absolute;
    width: 100%;
    top: 0.56rem;
    font-size: 0.26rem;
    left: 0;
    color: #282828;
    font-weight: normal;
    background-color: #fff;
    border-radius: 0.1rem 0.1rem 0.1rem 0.1rem;
    box-shadow: 0 0.02rem 0.12rem 0 rgba(0,0,0,0.2);
    transition: all linear 0.2s;
    height: 0;
    overflow:hidden;
    text-align: center;
    span {
        display: block;
        padding: 0.1rem 0.08rem 0.1rem 0.08rem;
        border-bottom: 1px solid #ccc;
    }
    .active {
        color: #6173bf;
    }

  }
  .menuActive {
      height: 3rem;
  }
  span {
    margin-right: 0.05rem;
    cursor: pointer;
    &.active {
      font-weight: bold;
    }
  }
}
</style>
